import { render, staticRenderFns } from "./Release500.vue?vue&type=template&id=6f94e595"
import script from "./Release500.vue?vue&type=script&lang=js"
export * from "./Release500.vue?vue&type=script&lang=js"
import style0 from "./Release500.vue?vue&type=style&index=0&id=6f94e595&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports